import "./StepsProgressBar.scss";
import React from "react";
import ReleasedInactiveIcon from "../../assets/images/icons/progressbar/released_inactive.png";
import AcceptedInactiveIcon from "../../assets/images/icons/progressbar/accepted_inactive.png";
import CompletedInactiveIcon from "../../assets/images/icons/progressbar/completed_inactive.png";
import ReleasedActiveIcon from "../../assets/images/icons/progressbar/released_active.png";
import AcceptedActiveIcon from "../../assets/images/icons/progressbar/accepted_active.png";
import CompletedActiveIcon from "../../assets/images/icons/progressbar/completed_active.png";
import { Image } from "react-bootstrap";
import {
  CollaborationStatus,
  CommunityRequestStatus,
  CommunityRequestAssetStatus,
} from "../../constants";

function StepsProgressBar({
  currentStep,
  communityRequestStatus,
  assetsStatus,
}) {
  const steps = [
    {
      id: 1,
      label: "Released",
      icon: { inactive: ReleasedInactiveIcon, active: ReleasedActiveIcon },
    },
    {
      id: 2,
      label: "Accepted",
      icon: { inactive: AcceptedInactiveIcon, active: AcceptedActiveIcon },
    },
    {
      id: 3,
      label: "Completed",
      icon: { inactive: CompletedInactiveIcon, active: CompletedActiveIcon },
    },
  ];
  const assetsRejected =
    assetsStatus ===
    CommunityRequestAssetStatus.COMMUNITY_REQUEST_ASSETS_ACTIVITY_REJECTED;

  if (
    communityRequestStatus ===
    CommunityRequestStatus.COMMUNITY_REQUEST_STATUS_CANCELLED
  )
    return <></>;
  return (
    <ul className="step-progressbar my-4">
      {steps.map((step, index) => {
        let stepState = "";
        if (assetsRejected && index > 1) return <></>;
        if (assetsRejected && index === 1) {
          stepState = "rejected";
        } else if (
          currentStep ===
          CollaborationStatus.COMMUNITY_REQUEST_ASSETS_ACTIVITY_REJECTED
        ) {
          if (
            index + 1 ===
            CollaborationStatus.COMMUNITY_REQUEST_ASSETS_ACTIVITY_ACCEPTED
          ) {
            stepState = "rejected";
          } else if (
            index <
            CollaborationStatus.COMMUNITY_REQUEST_ASSETS_ACTIVITY_ACCEPTED
          ) {
            stepState = "complete";
          }
        } else {
          if (index < currentStep) stepState = "complete";
          else if (currentStep === index) stepState = "active";
        }
        return (
          <li className={`step ${stepState}`} key={step.id}>
            <div
              className={`d-flex justify-content-center align-items-center gap-0 ${
                stepState === "rejected" ? "mt-1" : "mt-2"
              }`}>
              <Image
                src={
                  (stepState === "active" || stepState === "complete") &&
                  !assetsRejected
                    ? step.icon.active
                    : step.icon.inactive
                }
              />{" "}
              <span>{stepState === "rejected" ? "Rejected" : step.label}</span>
            </div>
          </li>
        );
      })}
    </ul>
  );
}

export default StepsProgressBar;
